<mat-expansion-panel
  class="enx-expansion-panel"
  hideToggle
  (opened)="panelOpenState = true"
  (closed)="panelOpenState = false"
>
  <mat-expansion-panel-header [collapsedHeight]="'auto'" [expandedHeight]="'auto'">
    <mat-panel-title class="text-body-semibold">{{ title() }}</mat-panel-title>
    <mat-panel-description>
      <mat-icon class="text-green" [svgIcon]="panelOpenState ? 'minus' : 'plus'"></mat-icon>
    </mat-panel-description>
  </mat-expansion-panel-header>
  <p class="text-body-2-regular">{{ content() }}</p>
</mat-expansion-panel>
